export const referrals = {
  appBarTitle: "الإحالات",
  referralsList: {
    totalReferrals: "إجمالي عدد الإحالات",
    totalRegisteredInvitees: "إجمالي عدد المدعوين المسجلين",
    totalPendingInvitees: "إجمالي عدد المدعوين المعلقين",
    totalExpiredRewards: "إجمالي عدد الجوائز المنتهية",
    table: {
      inviterName: "اسم الداعي",
      inviterRole: "دور الداعي",
      invitationDate: "تاريخ الدعوة",
      inviteeName: "اسم المدعو",
      inviteePhoneNumber: "رقم هاتف المدعو",
      inviteeRole: "دور المدعو",
      inviteeRoleStatus: "حالة الدور للمدعو",
      inviteeStatus: "حالة المدعو",
      registerationDate: "تاريخ التسجيل",
      switchedFrom: "متغير من",
      roleStatusOptions: {
        primary: "اساسي",
        switched: "متغير",
      },
    },
    status: {
      unregistered: "غير مسجل",
      failed: "فشل",
      unverified: "غير مُتحقق",
      verified: "مُتحقق",
      acitve: "نشط",
    },
    roles: {
      singleOwner: "سائق حر",
      fleetOwner: "صاحب أسطول",
      driver: "سائق في أسطول",
    },
  },
  referralsRewards: {
    totalEarnedRewards: "إجمالي الجوائز المستحقة",
    totalNumberRedeemedRewards: "إجمالي الجوائز المكتسبة",
    totalAmountRedeemedRewards: "إجمالي مبلغ الجوائز المكتسبة",
    table: {
      inviterName: "اسم الداعي",
      inviterRole: "دور الداعي",
      inviterPhoneNumber: "رقم هاتف الداعي",
      NumberOfreferrals: "عدد الإحالات",
      numberOfEarnedRewards: "عدد الجوائز المستحقة",
      numberOfRedeemedRewards: "عدد الجوائز المكتسبة",
      numberOfSelectedRewards: "عدد الجوائز المختارة",
      numberOfExpiredRewards: "عدد الجوائز المنتهية",
      totalAmountRedeemed: "إجمالي المبلغ المكتسب (ج.م)",
    },
  },
};
